import { render, staticRenderFns } from "./ReporteProductos.vue?vue&type=template&id=413e4f28&scoped=true"
import script from "./ReporteProductos.vue?vue&type=script&lang=js"
export * from "./ReporteProductos.vue?vue&type=script&lang=js"
import style0 from "./ReporteProductos.vue?vue&type=style&index=0&id=413e4f28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413e4f28",
  null
  
)

export default component.exports